import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { environment } from 'environments/environment';

export const GLOBALS = {

  loaders: { page: false, box: false },

  pageActions: { create: 'create', update: 'update', view: 'view', correction: 'correction' },

  animations: {
    scale: { value: '*', params: { delay: '100ms', scale: '0.2' } },
    y: { value: '*', params: { delay: '100ms', y: '-25px' } },
    x: { value: '*', params: { delay: '100ms', x: '-25px' } },
    matTable: { value: '50' },
    icon: { value: '*', params: { delay: '50ms', scale: '0.2' } },
    listTitle: { value: '*', params: { delay: '100ms', x: '-25px' } }
  },

  pagination: {
    pageSize: 30,
    pageSizeOptions: [30, 35, 40, 45, 50]
  },

  // Invoice status
  invoiceStatuses: { active: 'active', inactive: 'inactive' },
  invoiceOrQuote: { invoice: 'invoice', quote: 'quote' },

  /** tinyMce Config */
  tinyMce: {
    base_url: '/tinymce',
    suffix: '.min',
    images_upload_url: environment.yiiUrl + 'cms-pages/post-image',
    images_upload_handler: (blobInfo, progress) => new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.open('POST', environment.yiiUrl + 'cms-pages/post-image');
      
      xhr.upload.onprogress = (e) => {
        progress(e.loaded / e.total * 100);
      };
      
      xhr.onload = () => {
        if (xhr.status === 403) {
          reject({ message: 'HTTP Error: ' + xhr.status, remove: true });
          return;
        }
    
        if (xhr.status < 200 || xhr.status >= 300) {
          reject('HTTP Error: ' + xhr.status);
          return;
        }
    
        const json = JSON.parse(xhr.responseText);
        if (!json || typeof json.link != 'string') {    //json.link contains the image upload url/location
          reject('Invalid JSON: ' + xhr.responseText);
          return;
        }
    
        resolve(json.link);
      };
      
      xhr.onerror = () => {
        reject('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
      };    
      
      const formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      formData.append('model_id', 'tinymce'); // Generic model id (folder name) for media upload inside tinyMCE
      formData.append('model_name', 'cms_media');
      xhr.send(formData);
    }),
    setup: (editor) => {
      editor.on('focus', (e) => { });
    },
    automatic_uploads: true,
    height: 500,
    toolbar_mode: 'sliding',
    menubar: false,
    plugins: [
      'advlist', 
      'autolink', 
      'lists', 
      'link', 
      'media', 
      'image', 
      'charmap', 
      'preview', 
      'anchor', 
      'searchreplace', 
      'visualblocks', 
      'code', 
      'fullscreen', 
      'insertdatetime', 
      'media', 
      'table', 
      'help', 
      'wordcount',
      'image', 
      'code', 
    ],    
    toolbar:
      'undo redo | blocks | fontfamily | fontsize | forecolor | bold italic | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | image code | link | media',
    font_family_formats:
      "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; DM Serif Display=dm serif display,sans-serif; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Montserrat=montserrat,sans-serif; Open Sans=open sans; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
    content_style:
      "@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400&display=swap');@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap');@import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&display=swap')",
    license_key: 'gpl' // Replace with actual license key
  },
};

export class CustomValidators {

  static validateDate: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    /// TODO: Implement some better validation logic
    const invalid = new Date(control.get('period_from').value) > new Date(control.get('period_to').value);

    /// TODO: Implement some logic to mark controls dirty if is necessary.
    return invalid ? { invalidDate: true } : null;
  }
}
